import { getJoinFunnelSource } from '../config/funnelIdentity';

export function getFunnelLocale(): 'en' | 'es' {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    const isEs =
        hostname.includes('-es.') ||
        hostname.startsWith('es.') ||
        pathname.startsWith('/es/') ||
        pathname === '/es';

    return isEs ? 'es' : 'en';
}

/** Join funnel source — always Join-funnel (not hostname-derived). */
export function getFunnelSource(): string {
    return getJoinFunnelSource(getFunnelLocale() === 'es');
}

/**
 * Fire-and-forget Loops event sender.
 * Does NOT await — never blocks the funnel flow.
 */
export function fireLoopsEvent(
    eventName: string,
    props: Record<string, any>
) {
    fetch('/api/loops-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            eventName,
            ...props,
        }),
    }).catch(() => { /* fire and forget */ });
}
